import { useState } from "react";
import Step1DetailsForm from "./Step1DetailsForm";
import Step2MediaForm from "./Step2MediaForm";
import Step3PreviewForm from "./Step3PreviewForm";
import { ProgressBar } from "react-bootstrap";

const PromotionForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    media: { images: [], promotion_videos: [], attachments: [] }
  });

  const updateFormData = (newData) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };
  console.log("Current Form Data:", formData); 

  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep(prev => prev - 1);

  return (
    <div className="card shadow-sm p-4">
      <ProgressBar now={(step / 3) * 100} className="mb-4" />
      {step === 1 && 
        <Step1DetailsForm 
          nextStep={nextStep} 
          updateFormData={updateFormData} 
          initialData={formData} 
        />
      }
      {step === 2 && 
        <Step2MediaForm 
          media={formData.media}
          setMedia={(media) => updateFormData({ media })}
          onPrevious={prevStep}
          onNext={(mediaData) => {
            updateFormData({ media: mediaData });
            nextStep();
          }}
        />
      }
      {step === 3 && 
        <Step3PreviewForm 
          prevStep={prevStep} 
          formData={formData} 
        />
      }
    </div>
  );
};

export default PromotionForm;
